import React, { useEffect, useRef } from 'react';
import { Box, Chip, Switch, Typography } from '@mui/material';
import { colors } from '../../assets/utils/colors';

// RTK query
import {
    useActivatePromotionMutation,
    useDeactivatePromotionMutation,
} from '../../api/promotions/promotionAPI';
import { toast } from 'react-hot-toast';

const PromotionWidget2 = ({ promotion, refetch }) => {
    const [
        activatePromo,
        { isSuccess, isError, data: actives },
    ] = useActivatePromotionMutation();
    const [
        deActivatePromo,
        { isSuccess: success, isError: error, data: deacticves },
    ] = useDeactivatePromotionMutation();
    const { promotion_name, promotion_image, status } = promotion;
    const checkedRef = useRef();

    const activatePromotion = async (e) => {
        if (!checkedRef.current.checked) {
            await activatePromo(promotion.id);
        } else {
            await deActivatePromo(promotion.id);
        }
    };

    useEffect(() => {
        if (isSuccess) {
            toast.success(actives?.message);
            refetch();
        }

        if (isError) {
            toast.error(
                'oops! failed to activate promotion. Please try again later',
            );
        }

        if (success) {
            toast.success(deacticves?.message);
            refetch();
        }

        if (error) {
            toast.error(
                'oops! failed to deactivate promotion. Please try again later',
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSuccess, success, error, isError]);

    return (
        <>
            <Box
                sx={{
                    overflow: 'hidden',
                    border: `1px solid ${colors.bgColor1}`,
                    background: `linear-gradient(180deg, ${colors.bgColor1}, ${colors.bgColor2})`,
                    transition: '.2s all ease-in-out',
                    boxShadow: `2px 2px 10px 4px ${colors.bgColor3}`,
                }}
            >
                <Box>
                    <img
                        src={promotion_image}
                        alt=""
                        style={{ width: '100%', height: 150 }}
                    />
                </Box>
                <Box
                    sx={{
                        background: `linear-gradient(180deg, ${colors.bgColor1}, ${colors.bgColor1})`,
                        p: 1.5,
                    }}
                >
                    <Typography
                        sx={{
                            fontWeight: 'bold',
                            color: colors.primary,
                            fontSize: 13,
                        }}
                    >
                        {promotion_name}
                    </Typography>
                </Box>
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        mt: 0.5,
                    }}
                >
                    <Box
                        sx={{
                            width: '100%',
                            textAlign: 'center',
                        }}
                    >
                        <Typography
                            sx={{
                                fontSize: 12,
                                fontWeight: 'bold',
                            }}
                        >
                            Products
                        </Typography>
                        <Typography sx={{ fontSize: 13 }}>50</Typography>
                    </Box>
                    <Box
                        sx={{
                            width: '100%',
                            textAlign: 'center',
                            borderLeft: '1px solid green',
                            borderRight: '1px solid green',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        {status === 1 ? (
                            <Chip size="small" color="success" label="active" />
                        ) : (
                            <Chip size="small" color="error" label="inactive" />
                        )}
                        {status === 1 ? (
                            <Switch
                                size="small"
                                defaultChecked={true}
                                inputRef={checkedRef}
                                onChange={(e) =>
                                    activatePromotion(e.target.checked)
                                }
                            />
                        ) : (
                            <Switch
                                size="small"
                                defaultChecked={false}
                                inputRef={checkedRef}
                                onChange={(e) =>
                                    activatePromotion(e.target.checked)
                                }
                            />
                        )}
                    </Box>
                </Box>
            </Box>
        </>
    );
};

export default PromotionWidget2;
